function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1 1l7.228 6.874a.851.851 0 010 1.248L1 16"
});

function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17
  }, props), _ref);
}

export default SvgNext;